// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__HbA4F","detailsBorder":"styles_detailsBorder__2Z-cx"};